import { parsePayload } from './isomorphic-git/parse-payload';

export async function sanitizePayload(rawBytes: Uint8Array): Promise<string | null> {
  try {
    return parsePayload(rawBytes);
  } catch (err) {
    return null;
  }
}
